// src/context/brandVoice/ui/GrowingTextarea.jsx — the text box every Brand Voice list editor uses.
//
// ⛔ No real line breaks anywhere on this screen: the backend collapses every whitespace run
// into one space before storing (sheet 08, common rule 1). So editors block Enter and pass
// typed/pasted text through `oneLine`; the box still WRAPS and grows with its text instead of
// scrolling. (Moved out of PairListEditor.jsx in v186 — the str_list editor uses it too.)
import React, { useLayoutEffect, useRef } from 'react';

/** Any line break → one space (a paste can carry \r\n). */
export const oneLine = (s) => s.replace(/\r\n|\r|\n/g, ' ');

/** Enter would insert a line break the backend silently collapses: block it. */
export const blockEnter = (e) => { if (e.key === 'Enter') e.preventDefault(); };

// A textarea that soft-wraps and grows with its text instead of scrolling.
// v200 `fitPlaceholder`: an EMPTY box grows to its placeholder too (scrollHeight ignores a placeholder), so a long
// placeholder in a narrow column is read whole. Measured by putting the placeholder in the box for the measurement
// only — the controlled value is restored at once, no event fires.
export default function GrowingTextarea({ value, style, fitPlaceholder = false, placeholder, ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    const measurePlaceholder = fitPlaceholder && !value && !!placeholder;
    if (measurePlaceholder) el.value = placeholder;
    el.style.height = `${el.scrollHeight}px`;
    if (measurePlaceholder) el.value = '';
  }, [value, fitPlaceholder, placeholder]);
  return (
    <textarea
      ref={ref}
      rows={1}
      value={value}
      placeholder={placeholder}
      style={{ ...style, resize: 'none', overflow: 'hidden' }}
      {...rest}
    />
  );
}
